<div class="admin-dialog">
  <!-- Header -->
  <div class="admin-dialog__header">
    <div class="admin-dialog__header-left">
      <h2 class="admin-dialog__title" i18n="@@adminSystem.userDataTemplateDetails.title.template">ユーザーデータテンプレート</h2>
    </div>
    <button mat-icon-button class="admin-dialog__close" (click)="onNoClick()" aria-label="Close dialog" type="button">
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <!-- Content -->
  <div class="admin-dialog__content">
    <form [formGroup]="userDataTemplateFormGroup">

      <div class="admin-dialog__section">
        <div class="form-label">
          <span class="form-label__text" i18n="@@adminSystem.userDataTemplateDetails.label.templateName">テンプレート名</span>
          <span class="form-label__required">*</span>
        </div>
        <mat-form-field appearance="outline" class="form-field">
          <input matInput formControlName="name" placeholder="--" i18n-placeholder="@@adminSystem.userDataTemplateDetails.placeholder.templateName" />
          <mat-icon matSuffix class="material-icons-outlined">description</mat-icon>
        </mat-form-field>
      </div>

      <div class="admin-dialog__section">
        <div class="form-label">
          <span class="form-label__text" i18n="@@adminSystem.userDataTemplateDetails.label.userDataSetting">ユーザーデータ 設定</span>
        </div>
        <mat-form-field appearance="outline" class="form-field form-field--full">
          <textarea matInput formControlName="template" rows="4" (input)="refreshPreviewAndErrors()" i18n-placeholder="@@adminSystem.userDataTemplateDetails.placeholder.template"></textarea>
        </mat-form-field>
      </div>

      @if (mode == Mode.input) {
        <div class="admin-dialog__section">
          <div class="form-label form-label--small">
            <span class="form-label__text" i18n="@@adminSystem.userDataTemplateDetails.label.errorCheck">エラーチェック</span>
          </div>
          <div class="preview-box">
            @for (error of errors; track error; let i = $index) {
              <div class="preview-box__line preview-box__line--error">{{ error }}</div>
            }
          </div>
        </div>
      }

      <div class="admin-dialog__section">
        <div class="form-label form-label--small">
          <span class="form-label__text" i18n="@@adminSystem.userDataTemplateDetails.label.preview">プレビュー</span>
        </div>
        <div class="preview-box">
          @for (line of preview; track line; let i = $index) {
            <div class="preview-box__line">{{ line }}</div>
          }
        </div>
      </div>

    </form>
  </div>

  <!-- Footer -->
  <div class="admin-dialog__footer">
    @if (mode === Mode.disp) {
      <button mat-stroked-button (click)="onNoClick()">
        <span i18n="@@adminSystem.userDataTemplateDetails.button.close">閉じる</span>
      </button>
    } @else {
      <button mat-stroked-button color="warn" (click)="onNoClick()">
        <span i18n="@@adminSystem.userDataTemplateDetails.button.discard">破棄</span>
      </button>
    }
    <button mat-flat-button color="primary" (click)="onEditOrUploadClicked()">
      <span i18n="@@adminSystem.userDataTemplateDetails.button.editOrSave">{{ mode === Mode.disp ? '編集' : '保存' }}</span>
    </button>
  </div>
</div>
